import { UserRole } from '../services/invitationService';
import { User, PostgrestError } from '@supabase/supabase-js';

// Company Size constants and type
export const COMPANY_SIZES = ['1-5', '5-10', '10-20', '20+'] as const;
export type CompanySize = (typeof COMPANY_SIZES)[number];

// Organization types
export interface Organization {
  id: string;
  name: string;
  slogan?: string;
  slug: string;
  logo_url?: string;
  settings?: Record<string, any>;
  role?: UserRole;
  created_at?: string;
}

// Paciente types
export interface Paciente {
  id: string;
  created_at?: string;
  updated_at?: string;
  organization_id?: string;

  cpf?: string;
  rg?: string;
  nome?: string;
  email?: string;
  data_nasc?: string;
  profissao?: string;
  celular?: string;
  convenio?: string;
  cep?: string;
  telefone?: string;
  logradouro?: string;
  celular_ii?: string;
  numero?: string;
  complemento?: string;
  obs?: string;
  bairro?: string;
  estado_civil?: string;
  municipio?: string;
  uf?: string;
}

export type TinyPacient = Pick<Paciente, 'id' | 'nome' | 'data_nasc'>;

// Consulta types
export interface Consulta {
  id: string;
  paciente_id?: string;
  created_at?: string;
  updated_at?: string;
  organization_id?: string;
  paciente?: TinyPacient;
  pacientes?: TinyPacient[];

  // Medical examination fields
  queixa?: string;
  cirurgia_oftalmologica?: boolean;
  dm?: boolean;
  has?: boolean;
  glaucoma_familia?: boolean;
  refracao?: 'dinamica' | 'estatica';

  // Eye examination fields
  od_esferico?: number | null;
  od_cilindrico?: number | null;
  od_eixo?: number | null;
  od_av?: string;
  oe_esferico?: number | null;
  oe_cilindrico?: number | null;
  oe_eixo?: number | null;
  oe_av?: string;
  adicao?: number | null;

  // Examination findings
  biomicroscopia?: string;
  fundo_de_olho?: string;
  pio?: string;
  conduta?: string;

  // Additional fields
  observacoes?: string;
  retorno?: string;
  receita?: string;
}

// Atendimento types
export interface Atendimento {
  id: string;
  organization_id: string;
  paciente_id: string;
  is_priority: boolean;
  joined_at: string;
  called_at?: string | null;
  finished_at?: string | null;
  canceled_at?: string | null;
  created_at: string;
  updated_at: string;
  paciente?: Paciente;
  pacientes?: Paciente;
}

export type AtendimentoStatus = 'waiting' | 'called' | 'finished' | 'canceled';

export type AtendimentoRole = 'recepcionist' | 'doctor' | 'monitor';

// User organization relationship
export interface UserOrganization {
  id: string;
  user_id: string;
  organization_id: string;
  role: UserRole;
  created_at: string;
  organizations?: Organization;
}

export interface PendingOrganization {
  organizationName: string;
  organizationSlogan?: string;
  companySize: CompanySize;
}

// Extended User type
export interface ExtendedUser extends Omit<User, 'user_metadata'> {
  user_metadata?: {
    name?: string;
    needs_password?: boolean;
    global_role?: string;
    pending_organization?: PendingOrganization;
  } | null;
}

export interface SupabaseError extends PostgrestError {
  status?: number;
}
